/**
 * API 엔드포인트 상수 정의
 * 모든 API 엔드포인트를 중앙에서 관리하여 유지보수성 향상
 */

export const ENDPOINTS = {
  // 인증
  LOGIN: "Login/signIn",

  // 자사용 메뉴 조회 (MenuJ1-7)
  MENUJ1_RETRIEVE: "MenuJ1/retrieve",
  MENUJ2_RETRIEVE: "MenuJ2/retrieve",
  MENUJ3_RETRIEVE: "MenuJ3/retrieve",
  MENUJ4_RETRIEVE: "MenuJ4/retrieve",
  MENUJ5_RETRIEVE: "MenuJ5/retrieve",
  MENUJ6_RETRIEVE: "MenuJ6/retrieve",
  MENUJ7_RETRIEVE: "MenuJ7/retrieve",

  // 업체용 메뉴 조회 (MenuO1-7)
  MENUO1_RETRIEVE: "MenuO1/retrieve",
  MENUO2_RETRIEVE: "MenuO2/retrieve",
  MENUO3_RETRIEVE: "MenuO3/retrieve",
  MENUO4_RETRIEVE: "MenuO4/retrieve",
  MENUO5_RETRIEVE: "MenuO5/retrieve",
  MENUO6_RETRIEVE: "MenuO6/retrieve",
  MENUO7_RETRIEVE: "MenuO7/retrieve",

  // 모니터링
  MONITORING: "Monitoring",
};

